import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  Input,
  ComponentRef,
  ComponentFactoryResolver,
  OnDestroy,
  EventEmitter,
  Output
} from '@angular/core';
import {
  Tarea,
  Context,
  DynamicComponentForm,
  Const
} from '@app/shared';
import * as _ from 'lodash';

@Component({
  selector: 'iw-dynamic-content-form',
  templateUrl: './dynamic-content-form.component.html',
  styleUrls: ['./dynamic-content-form.component.scss'],
  providers: []
})
export class DynamicContentFormComponent implements OnInit, OnDestroy {
  // Tarea que se usa para crear el formulario
  @Input() task: Tarea;
  // Contexto del formulario
  @Input() context: Partial<Context> = {};
  // Define cuando realizar el auto guardado de la tarea
  @Input() autoSave = false;
  // Define cuando la tarea es de liquidacion
  @Input() liquidation = false;
  // Define si el formulario es para previsualizar
  @Input() previewForm = false;
  // Evento general que ejecuta diferentes eventos dentro de la tarea
  @Output() event: EventEmitter<any> = new EventEmitter();
  // Referencia del ancla donde se renderizan los formularios
  @ViewChild('container', { read: ViewContainerRef })
  private containerRef: ViewContainerRef;
  // Refertencia del componente que representa el formulario
  private componentRef: ComponentRef<DynamicComponentForm>;

  constructor(private cfr: ComponentFactoryResolver) {}

  ngOnInit() {
    let context = _.merge(this.context, {
      task: this.task,
    });
    // Si es una tarea de tipo forma
    if (this.task.tarea_tipo.nombre === Const.TYPES_TASK.form) {
      context = _.merge(context, this.task.tarea_forma[0].parametros);
    }
    // Instanciar y configurar el componente que representa el formulario
    const factory = this.cfr.resolveComponentFactory(this.task.meta.formType.component);
    this.componentRef = this.containerRef.createComponent(factory);
    this.componentRef.instance.ctx = context;
    this.componentRef.instance.event = this.event;
    if (this.componentRef.instance['autoSave'] !== undefined) {
      this.componentRef.instance['autoSave'] = this.autoSave;
    }
    if(this.componentRef.instance['previewFlow'] !== undefined){
      this.componentRef.instance['previewFlow'] = this.previewForm;
    }
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dynamic-content-form/dynamic-content-form.component.ts